import classNames from 'classnames';
import amountFormat from '../../../../utils/amountFormat';
import { LiteTradePortfolioListItemLoaderStyled } from '../LiteTradePortfolio/styled/LiteTradePortfolioStyled';
import { Loader } from '../../../../components/Loader/Loader';
import React from 'react';
import useMarketDataCandleLastPriceParamsBySymbol from '../../hooks/useMarketDataCandleLastPriceParamsBySymbol';
import { ILiteTradeAssetSymbol } from '../../types/liteTradeReducer.t';

interface ILiteTradeMarketAssetPriceProps {
    symbol: ILiteTradeAssetSymbol,
}

function LiteTradeMarketAssetPrice(props: ILiteTradeMarketAssetPriceProps) {
    const { symbol } = props;

    const lastPriceParams = useMarketDataCandleLastPriceParamsBySymbol(symbol);

    return lastPriceParams?.close
        ? <>
            <div className={'f16'}>{lastPriceParams?.close || '-'}</div>
            <div className={classNames({
                'positive': lastPriceParams?.diffPercent > 0,
                'negative': lastPriceParams?.diffPercent < 0,
            })}>{amountFormat(lastPriceParams?.diffPercent || 0, 2, '', true)}%
            </div>
        </>
        : <LiteTradePortfolioListItemLoaderStyled>
            <Loader show={true} bg={'transparent'} size={'sm'}/>
        </LiteTradePortfolioListItemLoaderStyled>;
}

export default LiteTradeMarketAssetPrice;
